export default __webpack_public_path__ + "static/media/hr-benefit.8c062c6d.png";